import React from 'react';
import { AsyncAutosuggest } from 'components';

const VideoAutosuggest = ({ value, label, handleChange }) => (
	<AsyncAutosuggest
		name="video_id"
		label={label}
		value={value}
		displayField="title"
		remoteUrl="/api/v1/admin/videos"
		placeholder="Select"
		handleChange={handleChange}
	/>
);

export default VideoAutosuggest;
